import { Component } from '../core/Component';

/**
 * Player component for marking entities as player-controlled
 * Pure data component - no behavior/logic
 */
export class PlayerComponent extends Component {
  public fireRate: number;
  public lastFireTime: number;
  public isLocalPlayer: boolean;
  public playerId: string;

  constructor(
    fireRate: number = 0.3,
    isLocalPlayer: boolean = true,
    playerId: string = 'player1'
  ) {
    super();
    this.fireRate = fireRate;
    this.lastFireTime = 0;
    this.isLocalPlayer = isLocalPlayer;
    this.playerId = playerId;
  }

  public clone(): PlayerComponent {
    const clone = new PlayerComponent(
      this.fireRate,
      this.isLocalPlayer,
      this.playerId
    );
    clone.lastFireTime = this.lastFireTime;
    return clone;
  }
}
